//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";
import PortalAlerts from "../../../../app/components/PortalAlerts";

export const GetScreeningTemplateHTML = createAsyncThunk(
  "GetScreeningTemplateHTML",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingGetScreeningTemplateHTML(""));
      const response = await UsePortalApi(
        `Patient/GetScreeningTemplateHTML`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? 
        dispatch(gettingGetScreeningTemplateHTMLSuccess(response[0].entry)) : 
        dispatch(gettingGetScreeningTemplateHTMLClear())

      } else {
          // alert("No data found against selected service template")
          PortalAlerts("error" , "error" , "No data found against selected service template")
        dispatch(
          gettingGetScreeningTemplateHTMLFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingGetScreeningTemplateHTMLFailed(error));
    }
  }
);

const GetScreeningTemplateHTMLSlice = createSlice({
  name: "GetScreeningTemplateHTML",
  initialState: {
    GetScreeningTemplateHTML: null,
    isGetScreeningTemplateHTML: false,
    errorGetScreeningTemplateHTML: false,
  },
  reducers: {
    gettingGetScreeningTemplateHTML: (state, action) => {
      state.GetScreeningTemplateHTML = null;
      state.isGetScreeningTemplateHTML = true;
      state.errorGetScreeningTemplateHTML = false;
    },
    gettingGetScreeningTemplateHTMLSuccess: (state, action) => {
      state.GetScreeningTemplateHTML = action.payload;
      state.isGetScreeningTemplateHTML = false;
      state.errorGetScreeningTemplateHTML = false;
    },
    gettingGetScreeningTemplateHTMLFailed: (state, action) => {
      state.GetScreeningTemplateHTML = null;
      state.isGetScreeningTemplateHTML = false;
      state.errorGetScreeningTemplateHTML = true;
    },
    gettingGetScreeningTemplateHTMLClear: (state, action) => {
      state.GetScreeningTemplateHTML = null;
      state.isGetScreeningTemplateHTML = false;
      state.errorGetScreeningTemplateHTML = false;
    },
  },
});
export const {
  gettingGetScreeningTemplateHTML,
  gettingGetScreeningTemplateHTMLSuccess,
  gettingGetScreeningTemplateHTMLFailed,
  gettingGetScreeningTemplateHTMLClear,
} = GetScreeningTemplateHTMLSlice.actions;
export default GetScreeningTemplateHTMLSlice.reducer;
